export type UpscalePayload = {
  target_scale: number | null;
  target_height: number | null;
  target_width: number | null;
};

export enum ENHANCE_FORMAT {
  WEBP = 'WEBP',
  JPG = 'JPG',
  PNG = 'PNG',
}

export const getEnhancePayload = (width: number, height: number): UpscalePayload => {
  const minSize = 1024;
  const upscalePayload: UpscalePayload = {
    target_scale: 1,
    target_height: height,
    target_width: width,
  };
  const maxDimension = Math.max(width, height);

  if (maxDimension <= minSize) {
    upscalePayload.target_scale = 4;
  }

  if (maxDimension > minSize && maxDimension <= 4 * minSize) {
    if (width > height) {
      upscalePayload.target_width = 4 * minSize;
    }

    if (width <= height) {
      upscalePayload.target_height = 4 * minSize;
    }
  }

  if (maxDimension >= 4 * minSize) {
    upscalePayload.target_scale = 1;
  }

  return upscalePayload;
};
